import InputEmailChips from './InputEmailChips';
export default InputEmailChips;